module.exports = "/assets/8a15997de1aac9ea23f76572a4873e7d.svg";